import { STORE_KEY } from '../constants';
import type { State } from '../reducers/authReducers';

export default (state: GlobalState) => state[STORE_KEY] as State | undefined;
